module.exports = __webpack_public_path__ + "img/6-white.a7e29539.png";